import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconCSV = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
        data-fill-none
      >
        <g>
          <path
            d="M5.25098 23.2539H2.25098C1.85315 23.2539 1.47162 23.0959 1.19032 22.8146C0.909012 22.5333 0.750977 22.1517 0.750977 21.7539V2.25391C0.750977 1.85608 0.909012 1.47455 1.19032 1.19325C1.47162 0.911941 1.85315 0.753906 2.25098 0.753906H12.88C13.2775 0.753991 13.6588 0.911888 13.94 1.19291L19.812 7.06391C19.9512 7.20326 20.0617 7.36869 20.137 7.55074C20.2123 7.73279 20.2511 7.92789 20.251 8.12491V12.7539"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.251 8.25391H14.251C13.8532 8.25391 13.4716 8.09587 13.1903 7.81457C12.909 7.53326 12.751 7.15173 12.751 6.75391V0.753906"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.251 15.7539C10.4553 15.7539 9.69226 16.07 9.12966 16.6326C8.56705 17.1952 8.25098 17.9583 8.25098 18.7539V20.2539C8.25098 21.0496 8.56705 21.8126 9.12966 22.3752C9.69226 22.9378 10.4553 23.2539 11.251 23.2539"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.251 15.7539H15.751C15.3532 15.7539 14.9716 15.9119 14.6903 16.1932C14.409 16.4746 14.251 16.8561 14.251 17.2539C14.251 19.5039 17.251 19.5039 17.251 21.7539C17.251 22.1517 17.0929 22.5333 16.8116 22.8146C16.5303 23.0959 16.1488 23.2539 15.751 23.2539H14.251"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.251 15.7539V18.2999C20.251 20.0634 20.7729 21.7875 21.751 23.2549C22.729 21.7875 23.2509 20.0634 23.251 18.2999V15.7539"
            stroke="currentColor"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SvgIcon>
    );
  })
);
